(($) => {
  $(() => {
    const $animatedButtons = $('.btn-animated');

    if ($animatedButtons.length) {
      $animatedButtons.each((index, element) => {
        const $thisButton           = $(element);
        const $thisButtonBackground = $thisButton.find('.btn__background');

        $thisButton.on('mouseenter', (evt) => {
          const thisButtonOffset      = $thisButton.offset();
          const relativeX = evt.pageX - thisButtonOffset.left;
          const relativeY = evt.pageY - thisButtonOffset.top;
          $thisButtonBackground.css({
            "left": relativeX,
            "top": relativeY
          })
        })
      })
    }
  });
})(jQuery);
